import React from 'react';



const Footer = () => {
  return (
    <footer className="footer">
     
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Therapias. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;